// extracted by mini-css-extract-plugin
export const sectionFourColumnTiles = "fourColumnTiles-module--sectionFourColumnTiles--179lF";
export const sectionContent = "fourColumnTiles-module--sectionContent--3NLi5";
export const sectionContainer = "fourColumnTiles-module--sectionContainer--gR564";
export const sectionHeading = "fourColumnTiles-module--sectionHeading--Y931I";
export const sectionTiles = "fourColumnTiles-module--sectionTiles--39LOK";
export const tileItem = "fourColumnTiles-module--tileItem--XM1j8";
export const tiImageWrap = "fourColumnTiles-module--tiImageWrap--1UCDP";
export const tiContentWrap = "fourColumnTiles-module--tiContentWrap--1d1Gq";